import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import Field from "../../../components/Fields/Field";
import FieldLabel from "../../../components/Fields/FieldLabel";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";

interface IProps {
    show: boolean
    onHide: (applicationRoleId?: number) => void
}

interface ApplicationRoleCreateModel {
    name: string
    beginDate: string
    endDate?: string
}

const AddUserApplicationrolePopup: React.FC<IProps> = ({ show, onHide }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ApplicationRoleCreateModel>({
        name: '',
        beginDate: new FormatUtils().formatDateForStorage(new Date()),
        endDate: ''
    });

    function submit() {
        if (formData) {
            DataService
                .create<number>(`api/v1/ApplicationRoles`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide(response.data);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Role', validationRules: [{ type: 'isRequired' }] },
            { name: 'beginDate', label: 'Begin date', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'End date', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getLabelProps, getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Create application role'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('name')} />
                <Field {...getLabelProps('beginDate')}>
                    <DateControl {...getControlProps('beginDate')} />
                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                    <DateControl {...getControlProps('endDate')} />
                </Field>
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Create' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddUserApplicationrolePopup;